module.exports = __webpack_public_path__ + "4fa913de8cfaa3c77364b949544b3507.MP3";